// extracted by mini-css-extract-plugin
export default {"background":"fatimafigma_background__kJ29y","control":"fatimafigma_control__GSudB","figmaPhoto":"fatimafigma_figmaPhoto__XDR2y"};